var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 492,
    id: "svg181",
    sodipodiDocname: "roll.svg",
    inkscapeVersion: "1.2 (dc2aedaf03, 2022-05-15)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs185"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g179",
    transform: "translate(-3.0000244,-1.5000002)"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title98"
  }, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "g177"
  }, /*#__PURE__*/React.createElement("desc", {
    id: "desc100"
  }, "Created with Fabric.js 4.6.0"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    transform: "matrix(0.41,0,0,0.41,247.77,250)"
  }, /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    id: "g174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_25",
    transform: "translate(0,-150)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#ffffff",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    strokeWidth: 0,
    stroke: "#603fb8",
    strokeLinecap: " butt",
    d: "m -546.99994,-6.09756 h 100 v 100 h -100 z",
    transform: "translate(-50,-50)",
    vectorEffect: "non-scaling-stroke",
    id: "path102"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_24",
    transform: "matrix(2.79,0,0,2.79,0,-150)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#ff5670",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    stroke: "none",
    strokeLinecap: " butt",
    d: "m -193.05731,-9.68551 h -6 l -2.22187,-3.33375 c -0.33282,-0.49875 0.0234,-1.16625 0.62343,-1.16625 h 9.19684 c 0.6,0 0.9563,0.6675 0.6235,1.16625 z m -6,1.5 h 6 c 0.1781,0.11719 0.3797,0.24844 0.5672,0.39375 2.7,1.70156 8.4328,5.36715 8.4328,13.10625 0,2.4844 -2.0156,4.5 -4.5,4.5 h -15 c -2.48531,0 -4.5,-2.0156 -4.5,-4.5 0,-7.7391 5.73281,-11.40469 8.39062,-13.10625 0.22969,-0.14531 0.43126,-0.27656 0.60938,-0.39375 z m 3.9422,4.5 c 0,-0.52031 -0.4219,-0.94219 -0.9844,-0.94219 -0.4781,0 -0.9,0.42188 -0.9,0.94219 v 0.2813 c -0.2625,0.0562 -0.5531,0.1359 -0.7453,0.239 -0.69844,0.3188 -1.30781,0.9094 -1.45781,1.7672 -0.0844,0.4781 -0.0375,0.9422 0.15937,1.3594 0.19688,0.4125 0.50157,0.7031 0.81094,0.914 0.5438,0.3703 1.2609,0.586 1.8094,0.75 l 0.1031,0.0282 c 0.6562,0.2015 1.0969,0.3468 1.3734,0.5484 0.1172,0.0844 0.1594,0.15 0.1735,0.1922 0.0187,0.0375 0.0469,0.1219 0.014,0.3094 -0.0281,0.164 -0.1171,0.3047 -0.375,0.4125 -0.2859,0.1218 -0.75,0.1828 -1.35,0.089 -0.2812,-0.0468 -0.7828,-0.2156 -1.2281,-0.3656 -0.1031,-0.0375 -0.2062,-0.0703 -0.3,-0.1031 -0.49217,-0.1641 -1.02186,0.1031 -1.18593,0.5953 -0.16406,0.4922 0.10313,1.0219 0.59532,1.1437 0.0563,0.061 0.12656,0.0844 0.20625,0.1125 0.32812,0.1266 0.95156,0.3235 1.39686,0.4266 v 0.3 c 0,0.5203 0.4219,0.9422 0.9,0.9422 0.5625,0 0.9844,-0.4219 0.9844,-0.9422 v -0.2578 c 0.2484,-0.0469 0.4922,-0.1594 0.7172,-0.2156 0.7406,-0.3141 1.3312,-0.9235 1.4859,-1.8141 0.0844,-0.4875 0.0469,-0.9562 -0.1406,-1.3828 -0.1828,-0.4219 -0.4781,-0.7313 -0.7922,-0.9563 -0.5672,-0.4172 -1.3266,-0.6422 -1.8938,-0.8156 l -0.0796,-0.0094 c -0.6235,-0.2015 -1.0735,-0.3421 -1.3594,-0.539 -0.1219,-0.0844 -0.1594,-0.1406 -0.1688,-0.1641 -0.009,-0.0187 -0.0375,-0.075 -0.009,-0.2344 0.0187,-0.0937 0.089,-0.2484 0.3843,-0.3796 0.2625,-0.136 0.7688,-0.211 1.3407,-0.1641 0.2062,0.075 0.839,0.1969 1.0218,0.2437 0.4969,0.136 1.0125,-0.164 1.1438,-0.6656 0.1359,-0.4969 -0.1641,-1.0125 -0.6656,-1.1437 -0.2063,-0.0563 -0.675,-0.15 -0.9844,-0.2063 z",
    vectorEffect: "non-scaling-stroke",
    id: "path105"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_23",
    transform: "translate(0,-50)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#ffffff",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    strokeWidth: 0,
    stroke: "#603fb8",
    strokeLinecap: " butt",
    d: "m -546.99994,-6.09756 h 100 v 100 h -100 z",
    transform: "translate(-50,-50)",
    vectorEffect: "non-scaling-stroke",
    id: "path108"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_22",
    transform: "matrix(2.86,0,0,2.86,0,-50)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#fdb400",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    stroke: "none",
    strokeLinecap: " butt",
    d: "m -173.65489,5.61299 6.8026,0.99362 c 0.5633,0.07968 1.0367,0.47338 1.2166,1.01237 0.1799,0.54371 0.0331,1.13421 -0.374,1.53731 l -4.9327,4.79 1.1645,6.871 c 0.0947,0.5625 -0.1373,1.1343 -0.6107,1.467 -0.4686,0.3328 -1.0888,0.375 -1.5953,0.1078 l -6.0783,-3.2105 -6.07362,3.2105 c -0.51126,0.2672 -1.1314,0.225 -1.60006,-0.1078 -0.46866,-0.3327 -0.70535,-0.9045 -0.60594,-1.467 l 1.16454,-6.871 -4.93368,-4.79 c -0.40759,-0.4031 -0.55244,-0.9936 -0.3735,-1.53731 0.17847,-0.53899 0.65044,-0.93269 1.21803,-1.01237 l 6.79695,-0.99362 3.04868,-6.2022 c 0.2508,-0.51631 0.781,-0.84407 1.3586,-0.84407 0.5823,0 1.1125,0.32776 1.3633,0.84407 z",
    transform: "translate(-13.2,-12.7)",
    vectorEffect: "non-scaling-stroke",
    id: "path111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_21",
    transform: "translate(0,50)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#ffffff",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    strokeWidth: 0,
    stroke: "#603fb8",
    strokeLinecap: " butt",
    d: "m -546.99994,-6.09756 h 100 v 100 h -100 z",
    transform: "translate(-50,-50)",
    vectorEffect: "non-scaling-stroke",
    id: "path114"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_20",
    transform: "translate(0,150)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#ffffff",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    strokeWidth: 0,
    stroke: "#603fb8",
    strokeLinecap: " butt",
    d: "m -546.99994,-6.09756 h 100 v 100 h -100 z",
    transform: "translate(-50,-50)",
    vectorEffect: "non-scaling-stroke",
    id: "path117"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_19",
    transform: "matrix(2.74,0,0,2.74,0,50)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#36d058",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    stroke: "none",
    strokeLinecap: " butt",
    d: "m -175.28021,16.30721 -1.0898,4.725 c -0.1531,0.668 -0.7402,1.1353 -1.4279,1.1353 -11.826,-9e-4 -21.4448,-9.6196 -21.4448,-21.44621 0,-0.68718 0.4673,-1.275 1.13532,-1.42734 l 4.725,-1.08984 c 0.68812,-0.15947 1.39125,0.19772 1.67718,0.84937 l 2.1806,5.08594 c 0.2549,0.59906 0.083,1.29703 -0.42091,1.70859 l -2.52375,2.02639 c 1.59281,3.2447 4.23096,5.8828 7.47656,7.4766 l 2.0663,-2.5219 c 0.4072,-0.5053 1.1104,-0.6801 1.7095,-0.4207 l 5.0859,2.1802 c 0.6117,0.3218 1.0102,1.0343 0.8508,1.7186 z",
    transform: "translate(-12.39,-12.39)",
    vectorEffect: "non-scaling-stroke",
    id: "path120"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_18",
    transform: "matrix(2.86,0,0,2.86,0,150)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#a27ceb",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    stroke: "none",
    strokeLinecap: " butt",
    d: "m -189.40197,5.59299 1.64953,-4.71141 c 0.63141,-1.80515 2.33437,-3.01359 4.24687,-3.01359 h 8.49378 c 1.9125,0 3.614,1.20844 4.2469,3.01359 l 1.6499,4.71141 c 1.0875,0.45 1.8563,1.52344 1.8563,2.775 v 9 c 0,0.8297 -0.6703,1.5 -1.5,1.5 h -1.5 c -0.8297,0 -1.5,-0.6703 -1.5,-1.5 v -2.25 h -15 v 2.25 c 0,0.8297 -0.67172,1.5 -1.5,1.5 h -1.5 c -0.82828,0 -1.5,-0.6703 -1.5,-1.5 v -9 c 0,-1.25156 0.76688,-2.325 1.85672,-2.775 z m 3.25734,-0.225 h 13.77184 l -1.2234,-3.49687 c -0.2109,-0.6 -0.7781,-1.00313 -1.4156,-1.00313 h -8.49378 c -0.6375,0 -1.20468,0.40313 -1.41562,1.00313 z m -0.61406,3 c -0.82828,0 -1.5,0.6703 -1.5,1.5 0,0.8297 0.67172,1.5 1.5,1.5 0.82969,0 1.5,-0.6703 1.5,-1.5 0,-0.8297 -0.67031,-1.5 -1.5,-1.5 z m 15,3 c 0.8297,0 1.5,-0.6703 1.5,-1.5 0,-0.8297 -0.6703,-1.5 -1.5,-1.5 -0.8297,0 -1.5,0.6703 -1.5,1.5 0,0.8297 0.6703,1.5 1.5,1.5 z",
    transform: "translate(-12,-10.5)",
    vectorEffect: "non-scaling-stroke",
    id: "path123"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_17",
    transform: "translate(0,250)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#ffffff",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    strokeWidth: 0,
    stroke: "#603fb8",
    strokeLinecap: " butt",
    d: "m -546.99994,-6.09756 h 100 v 100 h -100 z",
    transform: "translate(-50,-50)",
    vectorEffect: "non-scaling-stroke",
    id: "path126"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_16",
    transform: "matrix(2.79,0,0,2.79,0,250)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#ff5670",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    stroke: "none",
    strokeLinecap: " butt",
    d: "m -193.05731,-9.68551 h -6 l -2.22187,-3.33375 c -0.33282,-0.49875 0.0234,-1.16625 0.62343,-1.16625 h 9.19684 c 0.6,0 0.9563,0.6675 0.6235,1.16625 z m -6,1.5 h 6 c 0.1781,0.11719 0.3797,0.24844 0.5672,0.39375 2.7,1.70156 8.4328,5.36715 8.4328,13.10625 0,2.4844 -2.0156,4.5 -4.5,4.5 h -15 c -2.48531,0 -4.5,-2.0156 -4.5,-4.5 0,-7.7391 5.73281,-11.40469 8.39062,-13.10625 0.22969,-0.14531 0.43126,-0.27656 0.60938,-0.39375 z m 3.9422,4.5 c 0,-0.52031 -0.4219,-0.94219 -0.9844,-0.94219 -0.4781,0 -0.9,0.42188 -0.9,0.94219 v 0.2813 c -0.2625,0.0562 -0.5531,0.1359 -0.7453,0.239 -0.69844,0.3188 -1.30781,0.9094 -1.45781,1.7672 -0.0844,0.4781 -0.0375,0.9422 0.15937,1.3594 0.19688,0.4125 0.50157,0.7031 0.81094,0.914 0.5438,0.3703 1.2609,0.586 1.8094,0.75 l 0.1031,0.0282 c 0.6562,0.2015 1.0969,0.3468 1.3734,0.5484 0.1172,0.0844 0.1594,0.15 0.1735,0.1922 0.0187,0.0375 0.0469,0.1219 0.014,0.3094 -0.0281,0.164 -0.1171,0.3047 -0.375,0.4125 -0.2859,0.1218 -0.75,0.1828 -1.35,0.089 -0.2812,-0.0468 -0.7828,-0.2156 -1.2281,-0.3656 -0.1031,-0.0375 -0.2062,-0.0703 -0.3,-0.1031 -0.49217,-0.1641 -1.02186,0.1031 -1.18593,0.5953 -0.16406,0.4922 0.10313,1.0219 0.59532,1.1437 0.0563,0.061 0.12656,0.0844 0.20625,0.1125 0.32812,0.1266 0.95156,0.3235 1.39686,0.4266 v 0.3 c 0,0.5203 0.4219,0.9422 0.9,0.9422 0.5625,0 0.9844,-0.4219 0.9844,-0.9422 v -0.2578 c 0.2484,-0.0469 0.4922,-0.1594 0.7172,-0.2156 0.7406,-0.3141 1.3312,-0.9235 1.4859,-1.8141 0.0844,-0.4875 0.0469,-0.9562 -0.1406,-1.3828 -0.1828,-0.4219 -0.4781,-0.7313 -0.7922,-0.9563 -0.5672,-0.4172 -1.3266,-0.6422 -1.8938,-0.8156 l -0.0796,-0.0094 c -0.6235,-0.2015 -1.0735,-0.3421 -1.3594,-0.539 -0.1219,-0.0844 -0.1594,-0.1406 -0.1688,-0.1641 -0.009,-0.0187 -0.0375,-0.075 -0.009,-0.2344 0.0187,-0.0937 0.089,-0.2484 0.3843,-0.3796 0.2625,-0.136 0.7688,-0.211 1.3407,-0.1641 0.2062,0.075 0.839,0.1969 1.0218,0.2437 0.4969,0.136 1.0125,-0.164 1.1438,-0.6656 0.1359,-0.4969 -0.1641,-1.0125 -0.6656,-1.1437 -0.2063,-0.0563 -0.675,-0.15 -0.9844,-0.2063 z",
    vectorEffect: "non-scaling-stroke",
    id: "path129"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_15",
    transform: "translate(0,350)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#ffffff",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    strokeWidth: 0,
    stroke: "#603fb8",
    strokeLinecap: " butt",
    d: "m -546.99994,-6.09756 h 100 v 100 h -100 z",
    transform: "translate(-50,-50)",
    vectorEffect: "non-scaling-stroke",
    id: "path132"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_14",
    transform: "matrix(2.86,0,0,2.86,0,350)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#fdb400",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    stroke: "none",
    strokeLinecap: " butt",
    d: "m -173.65489,5.61299 6.8026,0.99362 c 0.5633,0.07968 1.0367,0.47338 1.2166,1.01237 0.1799,0.54371 0.0331,1.13421 -0.374,1.53731 l -4.9327,4.79 1.1645,6.871 c 0.0947,0.5625 -0.1373,1.1343 -0.6107,1.467 -0.4686,0.3328 -1.0888,0.375 -1.5953,0.1078 l -6.0783,-3.2105 -6.07362,3.2105 c -0.51126,0.2672 -1.1314,0.225 -1.60006,-0.1078 -0.46866,-0.3327 -0.70535,-0.9045 -0.60594,-1.467 l 1.16454,-6.871 -4.93368,-4.79 c -0.40759,-0.4031 -0.55244,-0.9936 -0.3735,-1.53731 0.17847,-0.53899 0.65044,-0.93269 1.21803,-1.01237 l 6.79695,-0.99362 3.04868,-6.2022 c 0.2508,-0.51631 0.781,-0.84407 1.3586,-0.84407 0.5823,0 1.1125,0.32776 1.3633,0.84407 z",
    transform: "translate(-13.2,-12.7)",
    vectorEffect: "non-scaling-stroke",
    id: "path135"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_13",
    transform: "translate(0,450)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#ffffff",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    strokeWidth: 0,
    stroke: "#603fb8",
    strokeLinecap: " butt",
    d: "m -546.99994,-6.09756 h 100 v 100 h -100 z",
    transform: "translate(-50,-50)",
    vectorEffect: "non-scaling-stroke",
    id: "path138"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_12",
    transform: "translate(0,550)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#ffffff",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    strokeWidth: 0,
    stroke: "#603fb8",
    strokeLinecap: " butt",
    d: "m -546.99994,-6.09756 h 100 v 100 h -100 z",
    transform: "translate(-50,-50)",
    vectorEffect: "non-scaling-stroke",
    id: "path141"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_11",
    transform: "matrix(2.74,0,0,2.74,0,450)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#36d058",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    stroke: "none",
    strokeLinecap: " butt",
    d: "m -175.28021,16.30721 -1.0898,4.725 c -0.1531,0.668 -0.7402,1.1353 -1.4279,1.1353 -11.826,-9e-4 -21.4448,-9.6196 -21.4448,-21.44621 0,-0.68718 0.4673,-1.275 1.13532,-1.42734 l 4.725,-1.08984 c 0.68812,-0.15947 1.39125,0.19772 1.67718,0.84937 l 2.1806,5.08594 c 0.2549,0.59906 0.083,1.29703 -0.42091,1.70859 l -2.52375,2.02639 c 1.59281,3.2447 4.23096,5.8828 7.47656,7.4766 l 2.0663,-2.5219 c 0.4072,-0.5053 1.1104,-0.6801 1.7095,-0.4207 l 5.0859,2.1802 c 0.6117,0.3218 1.0102,1.0343 0.8508,1.7186 z",
    transform: "translate(-12.39,-12.39)",
    vectorEffect: "non-scaling-stroke",
    id: "path144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_10",
    transform: "matrix(2.86,0,0,2.86,0,550)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#a27ceb",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    stroke: "none",
    strokeLinecap: " butt",
    d: "m -189.40197,5.59299 1.64953,-4.71141 c 0.63141,-1.80515 2.33437,-3.01359 4.24687,-3.01359 h 8.49378 c 1.9125,0 3.614,1.20844 4.2469,3.01359 l 1.6499,4.71141 c 1.0875,0.45 1.8563,1.52344 1.8563,2.775 v 9 c 0,0.8297 -0.6703,1.5 -1.5,1.5 h -1.5 c -0.8297,0 -1.5,-0.6703 -1.5,-1.5 v -2.25 h -15 v 2.25 c 0,0.8297 -0.67172,1.5 -1.5,1.5 h -1.5 c -0.82828,0 -1.5,-0.6703 -1.5,-1.5 v -9 c 0,-1.25156 0.76688,-2.325 1.85672,-2.775 z m 3.25734,-0.225 h 13.77184 l -1.2234,-3.49687 c -0.2109,-0.6 -0.7781,-1.00313 -1.4156,-1.00313 h -8.49378 c -0.6375,0 -1.20468,0.40313 -1.41562,1.00313 z m -0.61406,3 c -0.82828,0 -1.5,0.6703 -1.5,1.5 0,0.8297 0.67172,1.5 1.5,1.5 0.82969,0 1.5,-0.6703 1.5,-1.5 0,-0.8297 -0.67031,-1.5 -1.5,-1.5 z m 15,3 c 0.8297,0 1.5,-0.6703 1.5,-1.5 0,-0.8297 -0.6703,-1.5 -1.5,-1.5 -0.8297,0 -1.5,0.6703 -1.5,1.5 0,0.8297 0.6703,1.5 1.5,1.5 z",
    transform: "translate(-12,-10.5)",
    vectorEffect: "non-scaling-stroke",
    id: "path147"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_9",
    transform: "translate(0,-550)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#ffffff",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    strokeWidth: 0,
    stroke: "#603fb8",
    strokeLinecap: " butt",
    d: "m -546.99994,-6.09756 h 100 v 100 h -100 z",
    transform: "translate(-50,-50)",
    vectorEffect: "non-scaling-stroke",
    id: "path150"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_8",
    transform: "matrix(2.79,0,0,2.79,0,-550)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#ff5670",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    stroke: "none",
    strokeLinecap: " butt",
    d: "m -193.05731,-9.68551 h -6 l -2.22187,-3.33375 c -0.33282,-0.49875 0.0234,-1.16625 0.62343,-1.16625 h 9.19684 c 0.6,0 0.9563,0.6675 0.6235,1.16625 z m -6,1.5 h 6 c 0.1781,0.11719 0.3797,0.24844 0.5672,0.39375 2.7,1.70156 8.4328,5.36715 8.4328,13.10625 0,2.4844 -2.0156,4.5 -4.5,4.5 h -15 c -2.48531,0 -4.5,-2.0156 -4.5,-4.5 0,-7.7391 5.73281,-11.40469 8.39062,-13.10625 0.22969,-0.14531 0.43126,-0.27656 0.60938,-0.39375 z m 3.9422,4.5 c 0,-0.52031 -0.4219,-0.94219 -0.9844,-0.94219 -0.4781,0 -0.9,0.42188 -0.9,0.94219 v 0.2813 c -0.2625,0.0562 -0.5531,0.1359 -0.7453,0.239 -0.69844,0.3188 -1.30781,0.9094 -1.45781,1.7672 -0.0844,0.4781 -0.0375,0.9422 0.15937,1.3594 0.19688,0.4125 0.50157,0.7031 0.81094,0.914 0.5438,0.3703 1.2609,0.586 1.8094,0.75 l 0.1031,0.0282 c 0.6562,0.2015 1.0969,0.3468 1.3734,0.5484 0.1172,0.0844 0.1594,0.15 0.1735,0.1922 0.0187,0.0375 0.0469,0.1219 0.014,0.3094 -0.0281,0.164 -0.1171,0.3047 -0.375,0.4125 -0.2859,0.1218 -0.75,0.1828 -1.35,0.089 -0.2812,-0.0468 -0.7828,-0.2156 -1.2281,-0.3656 -0.1031,-0.0375 -0.2062,-0.0703 -0.3,-0.1031 -0.49217,-0.1641 -1.02186,0.1031 -1.18593,0.5953 -0.16406,0.4922 0.10313,1.0219 0.59532,1.1437 0.0563,0.061 0.12656,0.0844 0.20625,0.1125 0.32812,0.1266 0.95156,0.3235 1.39686,0.4266 v 0.3 c 0,0.5203 0.4219,0.9422 0.9,0.9422 0.5625,0 0.9844,-0.4219 0.9844,-0.9422 v -0.2578 c 0.2484,-0.0469 0.4922,-0.1594 0.7172,-0.2156 0.7406,-0.3141 1.3312,-0.9235 1.4859,-1.8141 0.0844,-0.4875 0.0469,-0.9562 -0.1406,-1.3828 -0.1828,-0.4219 -0.4781,-0.7313 -0.7922,-0.9563 -0.5672,-0.4172 -1.3266,-0.6422 -1.8938,-0.8156 l -0.0796,-0.0094 c -0.6235,-0.2015 -1.0735,-0.3421 -1.3594,-0.539 -0.1219,-0.0844 -0.1594,-0.1406 -0.1688,-0.1641 -0.009,-0.0187 -0.0375,-0.075 -0.009,-0.2344 0.0187,-0.0937 0.089,-0.2484 0.3843,-0.3796 0.2625,-0.136 0.7688,-0.211 1.3407,-0.1641 0.2062,0.075 0.839,0.1969 1.0218,0.2437 0.4969,0.136 1.0125,-0.164 1.1438,-0.6656 0.1359,-0.4969 -0.1641,-1.0125 -0.6656,-1.1437 -0.2063,-0.0563 -0.675,-0.15 -0.9844,-0.2063 z",
    vectorEffect: "non-scaling-stroke",
    id: "path153"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_7",
    transform: "translate(0,-450)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#ffffff",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    strokeWidth: 0,
    stroke: "#603fb8",
    strokeLinecap: " butt",
    d: "m -546.99994,-6.09756 h 100 v 100 h -100 z",
    transform: "translate(-50,-50)",
    vectorEffect: "non-scaling-stroke",
    id: "path156"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_6",
    transform: "matrix(2.86,0,0,2.86,0,-450)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#fdb400",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    stroke: "none",
    strokeLinecap: " butt",
    d: "m -173.65489,5.61299 6.8026,0.99362 c 0.5633,0.07968 1.0367,0.47338 1.2166,1.01237 0.1799,0.54371 0.0331,1.13421 -0.374,1.53731 l -4.9327,4.79 1.1645,6.871 c 0.0947,0.5625 -0.1373,1.1343 -0.6107,1.467 -0.4686,0.3328 -1.0888,0.375 -1.5953,0.1078 l -6.0783,-3.2105 -6.07362,3.2105 c -0.51126,0.2672 -1.1314,0.225 -1.60006,-0.1078 -0.46866,-0.3327 -0.70535,-0.9045 -0.60594,-1.467 l 1.16454,-6.871 -4.93368,-4.79 c -0.40759,-0.4031 -0.55244,-0.9936 -0.3735,-1.53731 0.17847,-0.53899 0.65044,-0.93269 1.21803,-1.01237 l 6.79695,-0.99362 3.04868,-6.2022 c 0.2508,-0.51631 0.781,-0.84407 1.3586,-0.84407 0.5823,0 1.1125,0.32776 1.3633,0.84407 z",
    transform: "translate(-13.2,-12.7)",
    vectorEffect: "non-scaling-stroke",
    id: "path159"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_5",
    transform: "translate(0,-350)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#ffffff",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    strokeWidth: 0,
    stroke: "#603fb8",
    strokeLinecap: " butt",
    d: "m -546.99994,-6.09756 h 100 v 100 h -100 z",
    transform: "translate(-50,-50)",
    vectorEffect: "non-scaling-stroke",
    id: "path162"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_4",
    transform: "translate(0,-250)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#ffffff",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    strokeWidth: 0,
    stroke: "#603fb8",
    strokeLinecap: " butt",
    d: "m -546.99994,-6.09756 h 100 v 100 h -100 z",
    transform: "translate(-50,-50)",
    vectorEffect: "non-scaling-stroke",
    id: "path165"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_3",
    transform: "matrix(2.74,0,0,2.74,0,-350)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#36d058",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    stroke: "none",
    strokeLinecap: " butt",
    d: "m -175.28021,16.30721 -1.0898,4.725 c -0.1531,0.668 -0.7402,1.1353 -1.4279,1.1353 -11.826,-9e-4 -21.4448,-9.6196 -21.4448,-21.44621 0,-0.68718 0.4673,-1.275 1.13532,-1.42734 l 4.725,-1.08984 c 0.68812,-0.15947 1.39125,0.19772 1.67718,0.84937 l 2.1806,5.08594 c 0.2549,0.59906 0.083,1.29703 -0.42091,1.70859 l -2.52375,2.02639 c 1.59281,3.2447 4.23096,5.8828 7.47656,7.4766 l 2.0663,-2.5219 c 0.4072,-0.5053 1.1104,-0.6801 1.7095,-0.4207 l 5.0859,2.1802 c 0.6117,0.3218 1.0102,1.0343 0.8508,1.7186 z",
    transform: "translate(-12.39,-12.39)",
    vectorEffect: "non-scaling-stroke",
    id: "path168"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    transform: "matrix(2.86,0,0,2.86,0,-250)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: " nonzero",
    fill: "#a27ceb",
    strokeMiterlimit: 4,
    strokeLinejoin: " miter",
    strokeDashoffset: 0,
    strokeDasharray: "none",
    stroke: "none",
    strokeLinecap: " butt",
    d: "m -189.40197,5.59299 1.64953,-4.71141 c 0.63141,-1.80515 2.33437,-3.01359 4.24687,-3.01359 h 8.49378 c 1.9125,0 3.614,1.20844 4.2469,3.01359 l 1.6499,4.71141 c 1.0875,0.45 1.8563,1.52344 1.8563,2.775 v 9 c 0,0.8297 -0.6703,1.5 -1.5,1.5 h -1.5 c -0.8297,0 -1.5,-0.6703 -1.5,-1.5 v -2.25 h -15 v 2.25 c 0,0.8297 -0.67172,1.5 -1.5,1.5 h -1.5 c -0.82828,0 -1.5,-0.6703 -1.5,-1.5 v -9 c 0,-1.25156 0.76688,-2.325 1.85672,-2.775 z m 3.25734,-0.225 h 13.77184 l -1.2234,-3.49687 c -0.2109,-0.6 -0.7781,-1.00313 -1.4156,-1.00313 h -8.49378 c -0.6375,0 -1.20468,0.40313 -1.41562,1.00313 z m -0.61406,3 c -0.82828,0 -1.5,0.6703 -1.5,1.5 0,0.8297 0.67172,1.5 1.5,1.5 0.82969,0 1.5,-0.6703 1.5,-1.5 0,-0.8297 -0.67031,-1.5 -1.5,-1.5 z m 15,3 c 0.8297,0 1.5,-0.6703 1.5,-1.5 0,-0.8297 -0.6703,-1.5 -1.5,-1.5 -0.8297,0 -1.5,0.6703 -1.5,1.5 0,0.8297 0.6703,1.5 1.5,1.5 z",
    transform: "translate(-12,-10.5)",
    vectorEffect: "non-scaling-stroke",
    id: "path171"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoll);
export default __webpack_public_path__ + "static/media/roll.1ae7bf38e3b42a59dff01e4b7b7053ba.svg";
export { ForwardRef as ReactComponent };